export default "foo\n.bar\n.baz()\n"